import { cn } from '@shared/lib/utils';
import { sectionHeadingClassName } from '@shared/ui/formStyles';

/**
 * The Profile Settings drawer's text and control vocabulary — one definition per pattern, so the
 * six tabs cannot drift apart again. There is no Figma for this drawer: the reference is the rest
 * of the app (the shared formStyles and the Team drawer's reference form), and these build on it.
 */

/**
 * A section heading ("Billing Details", "Payment Methods") — the app's shared section heading with
 * a 12px gap below (mb-3, chosen for this drawer). Never zero this margin: Tailwind v4's `space-y-*`
 * spaces a stack with a bottom margin on each child (inside :where), so `mb-0` removes the gap
 * entirely rather than deferring to the stack. The heading's own margin wins instead, so every
 * heading in the drawer gets the same 12px whatever stack it sits in.
 */
export const sectionHeading = cn(sectionHeadingClassName, 'mb-3');

/** The sentence under a section heading ("Transfer account ownership to another user…"). */
export const sectionDescription = 'text-sm text-fg-secondary';

/** Title and supporting line inside a card (MFA, Auto Renewal, each notification preference). */
export const cardTitle = 'text-sm font-medium text-fg';
export const cardDescription = 'text-xs text-fg-muted mt-1';

/** Inner padding shared by every card in the drawer. */
export const cardPadding = 'p-4';

/** The row holding a tab's save action, ruled off from the form above it. */
export const saveRow = 'flex justify-end pt-4 border-t border-line';

/** A tab's save action. Pair with the Button default variant, which supplies --brand. */
export const saveButton = 'h-10 sm:h-11 px-6 rounded-xl text-sm font-medium';

/**
 * Segmented control — the drawer's own tab strip, reused by Payment's Card / ACH switch so the two
 * read as the same control.
 */
export const segmentedTrack = 'flex gap-1 bg-surface-field border border-line p-1 rounded-xl';

export function segmentedTab({ active, disabled = false }) {
  let state = 'text-fg-secondary hover:text-fg hover:bg-surface-hover';
  if (active) {
    state = 'bg-brand text-white shadow-md';
  } else if (disabled) {
    state = 'text-fg-disabled cursor-not-allowed';
  }
  return cn('flex flex-auto items-center justify-center px-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold leading-tight transition-all', state);
}
